import { PrimaryButton, ButtonText } from "./";
import React from "react";
import styled from "styled-components";
export const Icon = styled.i`
	color: black;
	font-size: 30px;
	&:before {
	}
`;
export const ButtonWrapper = styled.span`
	span {
		white-space: nowrap;
		width: auto;
	}
`;
export const ArrowButton = ({ Name, Url }) => {
	return (
		<ButtonWrapper>
			<PrimaryButton
				minwidth="113px"
				heightsmall="40px"
				margin="0"
				marginsmall="0"
				padding="0 0 0 15px"
				width="auto"
				href={Url}
				height="40px"
				noBorderLeftOnHover
			>
				<ButtonText padding="0" forcedFontSize="16px" forcedFontSizeSmall="16px">
					{Name}
				</ButtonText>
				<Icon className="icon-right-arrow"></Icon>
			</PrimaryButton>
		</ButtonWrapper>
	);
};
